export default __webpack_public_path__ + "static/jetson_background_perks-0759bfbf97eabc894e0e8bb918e428c4.png";